import Vue from 'vue';
import Buefy from 'buefy';
import App from './App.vue';
import router from './router';
import store from './store';
import Fetch from './utility/fetch';

Vue.config.productionTip = false;
Vue.use(Buefy);
Vue.use(Fetch);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
